import { ComponentRoute } from '@/classes'

const SuperadminSystemModuleRoutes = {
  SystemModuleView: new ComponentRoute('/superadmin/systemmodule', 'SystemModuleView'),
  SystemModulesDetail: new ComponentRoute('/superadmin/systemmodule', 'SystemModulesDetail')
}

export default SuperadminSystemModuleRoutes
